import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const SlideoutPanel = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer = null,
  width = '600px',
  closeOnBackdropClick = true,
  showCloseButton = true
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && closeOnBackdropClick) {
      onClose();
    }
  };

  const slideoutContent = (
    <div className={`slideout-overlay ${isOpen ? 'active' : ''}`}>
      <div 
        className="slideout-backdrop" 
        onClick={handleBackdropClick}
      />
      <div 
        className={`slideout-panel slideout-right ${isOpen ? 'slideout-open' : ''}`}
        style={{ width }}
      >
        {(title || showCloseButton) && (
          <div className="slideout-header">
            {title && <h2 className="slideout-title">{title}</h2>}
            {showCloseButton && (
              <button 
                className="modal-close" 
                onClick={onClose}
                aria-label="Close panel"
                type="button"
              >
                ×
              </button>
            )}
          </div>
        )}
        
        <div className="slideout-content">
          {children}
        </div>
        
        {footer && (
          <div className="slideout-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(slideoutContent, document.body);
};

export default SlideoutPanel;